import { render } from "./UserGuidelineBody.vue?vue&type=template&id=1de0e701&scoped=true"
const script = {}

import "./UserGuidelineBody.vue?vue&type=style&index=0&id=1de0e701&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de0e701"]])

export default __exports__